import { useAuthentication } from "../../context/index";

export function ProtectedView({ children }) {
  const { isPrivileged } = useAuthentication();
  return <>{isPrivileged && children}</>;
}
